import React, { useCallback, useState } from 'react';
import { Box, InputBase, makeStyles } from '@material-ui/core';
import DiaLog from '../../../../../components/Dialog';
import { i18n } from '../../../../../language';
import { systemAPI } from '../../../../../apis';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    color: '#7d86a9',
    fontSize: '0.875rem',
  },
  input: {
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
    fontSize: '1.125rem',
    border: 'solid 1px #e4e7eb',
    height: '3.5rem',
    borderRadius: '10px',
    paddingLeft: '1rem',
  },
}));

const AddHospital = ({ handleClose, handleRefresh }) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    hospitalName: '',
    hospitalCode: '',
  });

  const formHandler = useCallback(
    (type) => (event) => {
      setFormData((oldData) => ({
        ...oldData,
        [type]: event.target.value,
      }));
    },
    []
  );

  const submitHandler = useCallback(async () => {
    try {
      await systemAPI.createHospital(formData);
      handleRefresh();
    } catch (error) {
      console.log(error);
    }
  }, [formData, handleRefresh]);

  return (
    <DiaLog
      open={true}
      title={i18n.t('SETTING_ADD_HOSPITAL')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_ADD')}
      handleConfirm={submitHandler}
      handleClose={handleClose}
      handleCancel={handleClose}
    >
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem">
        <div className={classes.title}>{i18n.t('SETTING_HOSPITAL_POPUP_NAME')}*</div>
        <InputBase
          className={classes.input}
          value={formData.hospitalName}
          onChange={formHandler('hospitalName')}
          inputProps={{ maxLength: 60 }}
        />
      </Box>
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem" mt="2rem">
        <div className={classes.title}>{i18n.t('SETTING_HOSPITAL_CODE')}*</div>
        <InputBase
          className={classes.input}
          value={formData.hospitalCode}
          onChange={formHandler('hospitalCode')}
          inputProps={{ maxLength: 60 }}
        />
      </Box>
    </DiaLog>
  );
};

export default AddHospital;
